import script from "./checkins-settings.vue?vue&type=script&setup=true&lang=js"
export * from "./checkins-settings.vue?vue&type=script&setup=true&lang=js"

import "./checkins-settings.vue?vue&type=style&index=0&id=528485dc&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-528485dc"]])

export default __exports__